(function (window, document) {
  'use strict';
  if (window.KMCartGifts) return;

  var instances = new Map();
  var active = null;
  var selectedKey = 'kmEssentialGiftAutoOpenShown';
  var reminderKey = 'kmEssentialGiftDialogReminderAt';

  function readStorage(storage, key) {
    try { return storage && storage.getItem(key); } catch (error) { return null; }
  }

  function writeStorage(storage, key, value) {
    try { storage && storage.setItem(key, value); } catch (error) {}
  }

  function localStorage() {
    try { return window.localStorage; } catch (error) { return null; }
  }

  function sessionStorage() {
    try { return window.sessionStorage; } catch (error) { return null; }
  }

  function money(cents) {
    var currency = window.theme && window.theme.Currency;
    if (currency && currency.formatMoney) {
      return currency.formatMoney(cents, window.theme.settings.moneyFormat).replace(/<[^>]*>/g, '');
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function amountMessage(text, cents) {
    return String(text || '').replace(/\{\{\s*amount\s*\}\}/g, money(cents));
  }

  function renderMessage(node, text, cents) {
    var content = document.createDocumentFragment();
    var help = node.parentElement.querySelector('[data-km-gift-help]');
    String(text || '').split(/(\{\{\s*amount\s*\}\}|FREE Gift)/g).forEach(function (part) {
      if (part === 'FREE Gift' || /^\{\{/.test(part)) {
        var bold = document.createElement('strong');
        bold.textContent = part === 'FREE Gift' ? part : money(cents);
        if (part === 'FREE Gift') {
          bold.className = 'km-cart-gifts__term';
          if (help) bold.appendChild(help);
        }
        content.appendChild(bold);
      } else content.appendChild(document.createTextNode(part));
    });
    if (help && !content.contains(help)) content.appendChild(help);
    node.replaceChildren(content);
  }

  function track(name, extra) {
    var source = new URLSearchParams(window.location.search).get('source');
    var storage = sessionStorage();
    var location = source === 'edm' ? 'edm' : source != null ? 'cart'
      : readStorage(storage, 'kmEssentialGiftEntryLocation') || 'cart';
    writeStorage(storage, 'kmEssentialGiftEntryLocation', location);
    var payload = Object.assign({entry_location: location}, extra || {});
    if (typeof window.KMTrackGaEvent === 'function') window.KMTrackGaEvent(name, payload);
    else if (typeof window.gtag === 'function') window.gtag('event', name, payload);
    else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({event: name}, payload));
    }
  }

  function showError(instance, error) {
    const message = error ? error.code === 'KM_CART_TIMEOUT' ? error.message
      : instance.config.messages.genericError || error.message : '';
    instance.section.querySelectorAll('[data-km-gift-error]').forEach(function (node) {
      node.hidden = !error;
      node.textContent = message;
    });
    document.querySelectorAll('[data-km-cart-gift-checkout-error]').forEach(function (node) {
      node.hidden = !error;
      node.textContent = message;
    });
    document.querySelectorAll('[data-km-gift-checkout-status]').forEach(function (node) {
      node.hidden = !error;
    });
    if (error && instance.component) instance.component.hidden = false;
  }

  function removeFocus(namespace, container) {
    var a11y = window.theme && window.theme.a11y;
    if (a11y) a11y.removeTrapFocus({container: container, namespace: namespace});
    var root = document.documentElement;
    if (root.off) {
      root.off('focusout.' + namespace);
      root.off('keydown.' + namespace);
    }
  }

  function setMode(instance, giftId) {
    var dialog = instance.dialog;
    if (!dialog) return;
    instance.detailId = giftId || null;
    dialog.classList.toggle('is-detail', Boolean(giftId));
    var list = dialog.querySelector('[data-km-gift-list-view]');
    if (list) list.hidden = Boolean(giftId);
    dialog.querySelectorAll('[data-km-gift-detail-view]').forEach(function (view) {
      view.hidden = view.getAttribute('data-km-gift-detail-view') !== giftId;
    });
    var title = dialog.querySelector('[data-km-gift-dialog-title]');
    if (title) {
      if (!instance.titleIcon) {
        var titleIcon = title.querySelector('.km-gift-dialog__title-icon');
        if (titleIcon) instance.titleIcon = titleIcon.cloneNode(true);
      }
      title.replaceChildren();
      if (!giftId && instance.titleIcon) title.appendChild(instance.titleIcon.cloneNode(true));
      title.appendChild(document.createTextNode(giftId ? instance.config.messages.detailTitle : instance.config.messages.listTitle));
    }
    var back = dialog.querySelector('[data-km-gift-back]');
    if (back) back.hidden = !giftId;
    var subtitle = dialog.querySelector('[data-km-gift-dialog-subtitle]');
    if (subtitle) subtitle.hidden = Boolean(giftId);
    var remind = dialog.querySelector('[data-km-gift-remind-later]');
    if (remind) remind.hidden = Boolean(giftId) || !instance.openedAutomatically;
    var panel = dialog.querySelector('[data-km-gift-dialog-panel]');
    if (window.theme && window.theme.a11y && !dialog.hidden) {
      removeFocus('km_gift_focus', dialog);
      window.theme.a11y.trapFocus({container: dialog, elementToFocus: panel, namespace: 'km_gift_focus'});
    }
  }

  function openDialog(instance, automatically) {
    if (!instance.dialog || !instance.config.enabled) return;
    document.dispatchEvent(new CustomEvent('km:cart-gift-dialog-open'));
    instance.returnFocus = document.activeElement;
    instance.openedAutomatically = automatically === true;
    instance.dialog.hidden = false;
    document.documentElement.classList.add('km-gift-dialog-open');
    if (instance.drawer && instance.drawer.drawer.isOpen) {
      instance.drawer.drawer.unbindEvents();
      removeFocus('drawer_focus', instance.drawer.drawer.drawer);
      removeFocus('cartdrawer_focus', instance.drawer.form);
    }
    setMode(instance, null);
    track('view_gift_selection_modal', automatically ? {trigger: 'cart_threshold'} : {});
  }

  function closeDialog(instance) {
    if (!instance.dialog || instance.dialog.hidden) return;
    instance.dialog.hidden = true;
    document.documentElement.classList.remove('km-gift-dialog-open');
    removeFocus('km_gift_focus', instance.dialog);
    if (instance.drawer && instance.drawer.drawer.isOpen) {
      instance.drawer.drawer.bindEvents();
      if (window.theme.a11y) window.theme.a11y.trapFocus({container: instance.drawer.form,
        elementToFocus: instance.returnFocus || instance.drawer.form, namespace: 'cartdrawer_focus'});
    }
    if (instance.returnFocus && instance.returnFocus.isConnected) instance.returnFocus.focus();
    instance.detailId = null;
  }

  function setGalleryIndex(gallery, index) {
    if (!gallery) return;
    var slides = gallery.querySelectorAll('[data-km-gift-gallery-slide]');
    if (!slides.length) return;
    var next = (Number(index) % slides.length + slides.length) % slides.length;
    gallery.dataset.activeIndex = String(next);
    var trackNode = gallery.querySelector('[data-km-gift-gallery-track]');
    if (trackNode) trackNode.style.transform = 'translate3d(-' + next * 100 + '%,0,0)';
    slides.forEach(function (slide, i) { slide.setAttribute('aria-hidden', String(i !== next)); });
    gallery.querySelectorAll('[data-km-gift-gallery-index]').forEach(function (dot) {
      var selected = Number(dot.getAttribute('data-km-gift-gallery-index')) === next;
      dot.classList.toggle('is-active', selected);
      dot.setAttribute('aria-current', String(selected));
    });
  }

  function selectVariant(instance, detail, variantId) {
    var match = window.KMCartGiftRules.findGiftVariant(instance.config, variantId);
    if (!match || !match.variant.available || match.gift.id !== detail.getAttribute('data-km-gift-detail-view')) return;
    detail.dataset.selectedVariant = String(variantId);
    detail.querySelectorAll('[data-km-gift-variant]').forEach(function (button) {
      var selected = button.getAttribute('data-km-gift-variant') === String(variantId);
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', String(selected));
    });
    var gallery = detail.querySelector('[data-km-gift-gallery]');
    if (gallery && match.variant.image) {
      gallery.querySelectorAll('[data-km-gift-gallery-slide]').forEach(function (slide, index) {
        if (slide.getAttribute('data-km-gift-gallery-image') === match.variant.image) setGalleryIndex(gallery, index);
      });
    }
    if (instance.state) render(instance, Object.assign({}, instance.state, {cartChanged: false}));
  }

  function maybeAutoOpen(instance, cart) {
    var config = instance.config;
    if (!instance.dialog || !config.enabled || !config.autoOpen.enabled || instance.autoShown
      || instance.service.hasExplicitSelection() || !instance.dialog.hidden
      || readStorage(sessionStorage(), selectedKey) === '1') return;
    if (!config.gifts.some(function (gift) { return gift.variants.some(function (v) { return v.available; }); })) return;
    var reminder = Number(readStorage(localStorage(), reminderKey));
    if (reminder > 0 && Date.now() - reminder < 24 * 60 * 60 * 1000) return;
    var source = config.autoOpen.searchSourceEnabled && window.location.pathname.replace(/\/+$/, '') === '/search'
      && new URLSearchParams(window.location.search).has('source');
    var threshold = Number(config.autoOpen.thresholdCents) > 0
      ? Number(config.autoOpen.thresholdCents) : config.thresholds[0];
    if (!source && (!cart.items.length || window.KMCartGiftRules.getEligibleSubtotal(cart, config) < threshold)) return;
    instance.autoShown = true;
    writeStorage(sessionStorage(), selectedKey, '1');
    openDialog(instance, true);
  }

  function renderEmptyGifts(instance, isEmpty) {
    const preview = instance.section.querySelector('[data-km-empty-gifts]');
    if (!preview) return;
    preview.hidden = !isEmpty || !instance.config.enabled || !instance.config.gifts.length;
    if (preview.hidden) return;
    const giftsById = new Map(instance.config.gifts.map(gift => [gift.id, gift]));
    preview.querySelectorAll('[data-km-empty-gift]').forEach(card => {
      const gift = giftsById.get(card.dataset.kmEmptyGift);
      if (!gift) return;
      const variant = gift.variants.find(option => option.available && option.thresholdCents === gift.displayThresholdCents)
        || gift.variants.find(option => option.thresholdCents === gift.displayThresholdCents) || gift.variants[0];
      const compare = card.querySelector('[data-km-empty-gift-compare]');
      if (compare) compare.textContent = money(variant.comparePriceCents || variant.priceCents || gift.comparePriceCents || gift.priceCents || 0);
      const image = card.querySelector('[data-km-empty-gift-image]');
      const source = variant.image || gift.image;
      if (image && source) {
        const imageUrl = new URL(source, window.location.href);
        imageUrl.searchParams.set('width', '320');
        if (image.src !== imageUrl.href) image.src = imageUrl.href;
      }
    });
  }

  function render(instance, state) {
    instance.state = state;
    var config = instance.config;
    var cart = state.cart;
    document.querySelectorAll('#CartDrawerForm, #CartPageForm').forEach(function (form) {
      form.dataset.kmGiftPending = String(state.pending || !cart);
      form.dataset.kmGiftFailed = String(Boolean(state.error));
      if (form.kmCartForm && form.kmCartForm.updateCheckoutState) {
        form.kmCartForm.updateCheckoutState();
        return;
      }
      var button = form.querySelector('.cart__checkout');
      if (button) {
        button.disabled = state.pending || !cart || Boolean(state.error) || form.dataset.kmLegacyPending === 'true';
        button.setAttribute('aria-busy', String(state.pending));
      }
    });
    if (!cart) { showError(instance, state.error); return; }
    const isEmpty = cart.items.length === 0;
    renderEmptyGifts(instance, isEmpty);
    var rules = window.KMCartGiftRules;
    var total = rules.getEligibleSubtotal(cart, config);
    var progress = rules.getProgress(total, config.thresholds);
    var hasEligibleGift = cart.items.some(function (item) {
      if (!rules.isModernGift(item)) return false;
      var gift = rules.findGiftVariant(config, String(item.variant_id || item.id));
      return Boolean(gift && gift.variant.available && total >= gift.thresholdCents);
    });
    var giftComponent = instance.section.querySelector('.km-cart-gifts');
    if (giftComponent) giftComponent.classList.toggle('is-gift-added', hasEligibleGift);
    if (instance.component) instance.component.hidden = !config.enabled || !config.gifts.length;
    var message = instance.section.querySelector('[data-km-gift-message]');
    if (message) renderMessage(message, progress.nextThreshold == null ? config.messages.unlocked
      : config.messages.spendMore, progress.shortfall);
    var fill = instance.section.querySelector('[data-km-gift-progress]');
    if (fill) {
      const range = progress.steps.map(step => step.threshold + ':' + step.position).join('|');
      // Switch the labels and fill together. Animating between different ranges
      // would briefly carry the old highlight across a newly locked tier.
      fill.style.transition = instance.progressRange === range ? '' : 'none';
      fill.style.width = progress.percent + '%';
      instance.progressRange = range;
    }
    const progressSteps = instance.section.querySelector('[data-km-gift-progress-steps]');
    if (progressSteps) {
      const fragment = document.createDocumentFragment();
      progress.steps.forEach(({threshold, position, reached}) => {
        const step = document.createElement('span');
        step.className = 'km-cart-gifts__progress-step';
        step.classList.toggle('is-start', position === 0);
        step.classList.toggle('is-end', position === 100);
        step.dataset.threshold = String(threshold);
        step.classList.toggle('is-reached', reached);
        step.style.left = position + '%';
        const marker = document.createElement('i');
        marker.setAttribute('aria-hidden', 'true');
        const icon = document.createElement('img');
        icon.src = 'https://cdn.shopify.com/s/files/1/2234/5357/files/421661A7-37DF-49B1-9397-CF0B5A9F00A1.png?v=1791962432';
        icon.alt = '';
        icon.width = 12;
        icon.height = 12;
        marker.appendChild(icon);
        const label = document.createElement('b');
        label.textContent = money(threshold);
        step.append(marker, label);
        fragment.appendChild(step);
      });
      progressSteps.replaceChildren(fragment);
    }
    var match = isEmpty ? null : rules.findGiftVariant(config, state.selectedVariantId);
    config.gifts.forEach(function (gift) {
      instance.section.querySelectorAll('[data-km-gift-card], [data-km-gift-summary], [data-km-gift-detail-view]')
        .forEach(function (node) {
          var id = node.getAttribute('data-km-gift-card') || node.getAttribute('data-km-gift-summary')
            || node.getAttribute('data-km-gift-detail-view');
          if (id !== gift.id) return;
          if (node.getAttribute('data-km-gift-card') && match && match.gift.id === gift.id) {
            node.dataset.selectedVariant = match.variant.id;
          }
          var variant = gift.variants.find(function (value) { return value.id === node.dataset.selectedVariant; });
          var threshold = gift.displayThresholdCents;
          if (node.getAttribute('data-km-gift-detail-view') && variant) threshold = variant.thresholdCents;
          if (node.getAttribute('data-km-gift-summary') && match && match.gift.id === gift.id) threshold = match.thresholdCents;
          var unlocked = total >= threshold;
          node.classList.toggle('is-locked', !unlocked);
          node.classList.toggle('is-unlocked', unlocked);
          node.querySelectorAll('[data-km-gift-locked]').forEach(function (element) { element.hidden = unlocked; });
          node.querySelectorAll('[data-km-gift-unlocked]').forEach(function (element) { element.hidden = !unlocked; });
          node.querySelectorAll('[data-km-gift-shortfall], [data-km-gift-locked-shortfall]').forEach(function (element) {
            element.hidden = unlocked;
            element.textContent = amountMessage(config.messages.locked, Math.max(0, threshold - total));
          });
          node.querySelectorAll('[data-km-gift-threshold]').forEach(function (element) {
            element.textContent = amountMessage(config.messages.threshold, threshold);
          });
          node.querySelectorAll('[data-km-gift-variant]').forEach(function (button) {
            var option = gift.variants.find(function (value) { return value.id === button.getAttribute('data-km-gift-variant'); });
            if (!option) return;
            button.classList.toggle('is-locked', total < option.thresholdCents);
            button.classList.toggle('is-unlocked', total >= option.thresholdCents);
            var label = button.querySelector('[data-km-gift-variant-threshold-label]');
            if (label) label.textContent = amountMessage(config.messages.threshold, option.thresholdCents);
          });
          var add = node.querySelector('[data-km-gift-add]');
          if (add) {
            add.disabled = state.pending || !variant || !variant.available;
            add.textContent = variant && variant.available
              ? unlocked ? config.messages.addGift : config.messages.selectGift
              : variant ? config.messages.soldOut : config.messages.unavailable;
            add.setAttribute('aria-busy', String(state.pending));
          }
          var select = node.querySelector('[data-km-gift-select]');
          if (select) {
            var selectedVariant = String(node.dataset.selectedVariant || '').trim();
            var selected = Boolean(match && match.gift.id === gift.id && match.variant.id === selectedVariant);
            select.disabled = false;
            select.textContent = selected ? 'Selected' : 'Select';
            select.classList.toggle('is-selected', selected);
            select.setAttribute('aria-pressed', String(selected));
            select.removeAttribute('aria-busy');
            if (node.getAttribute('data-km-gift-card')) node.classList.toggle('is-selected', selected);
          }
        });
    });
    var selectedContainer = instance.section.querySelector('[data-km-selected-gift]');
    if (selectedContainer) {
      var preview = match || (config.gifts.length ? rules.findGiftVariant(config, config.gifts[0].variants[0].id) : null);
      selectedContainer.hidden = isEmpty || !preview;
      selectedContainer.classList.toggle('is-locked', Boolean(preview && (total < preview.thresholdCents || !preview.variant.available)));
      selectedContainer.querySelectorAll('[data-km-gift-summary]').forEach(function (summary) {
        summary.hidden = isEmpty || !preview || summary.getAttribute('data-km-gift-summary') !== preview.gift.id;
        if (summary.hidden) return;
        var label = summary.querySelector('[data-km-selected-variant-label]');
        if (label) {
          label.hidden = !preview.variant.title || preview.variant.title === 'Default Title';
          label.textContent = (config.messages.optionLabel || '') + ': ' + preview.variant.title;
        }
        var image = summary.querySelector('[data-km-selected-image]');
        if (image && (preview.variant.image || preview.gift.image)) image.src = preview.variant.image || preview.gift.image;
        var compare = summary.querySelector('[data-km-selected-compare-price]');
        if (compare) compare.textContent = money(preview.variant.comparePriceCents || preview.variant.priceCents
          || preview.gift.comparePriceCents || preview.gift.priceCents || 0);
        var unavailable = summary.querySelector('[data-km-selected-unavailable]');
        if (unavailable) unavailable.hidden = preview.variant.available;
      });
    }
    if (instance.component) {
      var notice = instance.component.querySelector('[data-km-gift-exclusion-notice]');
      if (notice) notice.hidden = !cart.items.some(function (item) {
        return !rules.isModernGift(item) && config.excludedSkus.indexOf(String(item.sku || '').trim().toUpperCase()) !== -1;
      });
    }
    showError(instance, state.error);
    if (!instance.entryTracked && instance.component && !instance.component.hidden) {
      instance.entryTracked = true;
      track('view_gift_entry');
    }
    if (!state.pending) {
      if (!cart.items.length && instance.hadCartItems) closeDialog(instance);
      else if (cart.items.length && !state.error && !instance.checkingOut) maybeAutoOpen(instance, cart);
      instance.hadCartItems = cart.items.length > 0;
      if (state.cartChanged && !instance.checkingOut) document.dispatchEvent(new CustomEvent('cart:build'));
    }
  }

  function init(section) {
    if (!section || instances.has(section)) return;
    var configNode = section.querySelector('#km-cart-gifts-config');
    if (!configNode) return;
    var instance = {section: section, component: section.querySelector('[data-km-essential-cart-content]'),
      dialog: section.querySelector('[data-km-gift-dialog]'), cleanup: [], checkoutBypass: new WeakSet(),
      checkoutPending: new WeakSet(), autoShown: false};
    try { instance.config = window.KMCartGiftRules.normalizeConfig(JSON.parse(configNode.textContent)); }
    catch (error) {
      instance.configError = error;
      instance.config = window.KMCartGiftRules.normalizeConfig({version: 1, enabled: false, gifts: [],
        messages: {genericError: 'Unable to load gift configuration. Please refresh.'}});
    }
    instances.set(section, instance);
    active = instance;
    if (section.querySelector('#CartDrawer') && window.theme && window.theme.CartDrawer
      && !document.body.classList.contains('template-cart')) instance.drawer = new window.theme.CartDrawer();
    instance.service = window.KMCreateCartGiftService({routes: instance.config.routes,
      cartState: window.KMCartState,
      fetchImpl: window.fetch.bind(window), rules: window.KMCartGiftRules,
      getConfig: function () {
        if (instance.configError) throw instance.configError;
        return instance.config;
      }, storage: localStorage()});
    window.KMCartGiftService = instance.service;

    function bind(target, event, callback, capture) {
      target.addEventListener(event, callback, capture);
      instance.cleanup.push(function () { target.removeEventListener(event, callback, capture); });
    }
    function refresh(event) {
      if (event && event.type === 'cart:rendered'
        && (instance.checkingOut || instance.state && instance.state.error)) return;
      const fresh = !event || event.type === 'drawerOpen.CartDrawer' || event.type === 'pageshow';
      instance.service.refresh({fresh}).catch(function () {});
    }
    ['cart:updated', 'ajaxProduct:added', 'cart:rendered', 'drawerOpen.CartDrawer'].forEach(function (event) {
      bind(document, event, refresh);
    });
    bind(window, 'pageshow', refresh);
    bind(document, 'click', function (event) {
      if (event.target.closest && event.target.closest('[data-km-gift-retry]')) refresh();
    });
    instance.cleanup.push(instance.service.subscribe(function (state) {
      if (instance.configError) state = Object.assign({}, state, {error: instance.configError});
      render(instance, state);
    }));

    bind(document, 'formdata', event => {
      if (!instance.checkoutPending.has(event.target)) return;
      // AJAX has already saved quantities. Old positional fields could otherwise
      // overwrite the freshly verified cart after a cross-tab change or gift swap.
      for (const name of [...event.formData.keys()]) {
        if (name === 'updates' || name.startsWith('updates[')) event.formData.delete(name);
      }
    }, true);

    bind(document, 'submit', function (event) {
      var form = event.target;
      if (!form.matches || !form.matches('#CartDrawerForm, #CartPageForm')) return;
      if (instance.checkoutBypass.has(form)) { instance.checkoutBypass.delete(form); return; }
      event.preventDefault();
      event.stopImmediatePropagation();
      if (instance.checkoutPending.has(form)) return;
      instance.checkoutPending.add(form);
      form.dataset.kmGiftCheckoutPending = 'true';
      form.dispatchEvent(new CustomEvent('cart:checkout-state', {bubbles: true}));
      instance.checkingOut = true;
      var submitter = event.submitter || form.querySelector('[name="checkout"]');
      let submissionCanceled = false;
      Promise.resolve().then(async function () {
        var nativeForm = form.kmCartForm;
        if (!nativeForm) throw new Error('Cart form unavailable');
        var revision;
        let verifiedVersion;
        do {
          if (nativeForm.waitForCartOperations) await nativeForm.waitForCartOperations();
          revision = nativeForm.cartMutationRevision || 0;
          await instance.service.prepareCheckout();
          verifiedVersion = window.KMCartState?.version;
          if (nativeForm.waitForCartOperations) await nativeForm.waitForCartOperations();
        } while (revision !== (nativeForm.cartMutationRevision || 0)
          || verifiedVersion !== window.KMCartState?.version);
        if (!instances.has(section) || !form.isConnected) return;
        instance.checkoutBypass.add(form);
        let finalSubmit;
        const captureSubmit = submitEvent => { finalSubmit = submitEvent; };
        form.addEventListener('submit', captureSubmit, true);
        try {
          if (submitter && submitter.disabled) throw new Error('Cart update pending');
          if (submitter) form.requestSubmit(submitter);
          else form.requestSubmit();
          submissionCanceled = !finalSubmit || finalSubmit.defaultPrevented;
        } finally {
          form.removeEventListener('submit', captureSubmit, true);
          instance.checkoutBypass.delete(form);
        }
      }).catch(function (error) { showError(instance, error); })
        .finally(function () {
          instance.checkoutPending.delete(form);
          instance.checkingOut = false;
          form.dataset.kmGiftCheckoutPending = 'false';
          form.dispatchEvent(new CustomEvent('cart:checkout-state', {bubbles: true}));
          // Terms or another submit handler can keep the customer on this page.
          // Refresh only then; successful checkout never waits for display HTML.
          if (submissionCanceled && instances.has(section) && form.isConnected) {
            form.kmCartForm.buildCart({reuse: true}).catch(error => showError(instance, error));
          }
        });
    }, true);

    bind(section, 'click', function (event) {
      var target = event.target.closest && event.target.closest('button');
      if (!target) {
        if (event.target === instance.dialog) {
          event.preventDefault();
          event.stopPropagation();
          closeDialog(instance);
        }
        return;
      }
      var help = target.matches('[data-km-gift-help]');
      if (help) {
        var tooltip = section.querySelector('[data-km-gift-help-tooltip]');
        if (tooltip) { tooltip.hidden = !tooltip.hidden; target.setAttribute('aria-expanded', String(!tooltip.hidden)); }
      } else if (target.matches('[data-km-gift-open]')) {
        event.preventDefault();
        track(instance.service.hasExplicitSelection() || target.closest('[data-km-selected-gift]')
          ? 'click_change_gift' : 'click_gift_options');
        openDialog(instance, false);
      } else if (target.matches('[data-km-gift-close]')) {
        event.preventDefault();
        event.stopPropagation();
        track('click_close_gift_selection_modal', {modal_level: instance.detailId ? 2 : 1});
        closeDialog(instance);
      } else if (target.matches('[data-km-gift-back]')) {
        track('click_back_to_gifts');
        setMode(instance, null);
      } else if (target.matches('[data-km-gift-select], [data-km-empty-gift-open]')) {
        const giftId = target.getAttribute('data-km-gift-select') || target.getAttribute('data-km-empty-gift-open');
        const gift = instance.config.gifts.find(value => value.id === giftId);
        if (!gift) return;
        if (instance.dialog && instance.dialog.hidden) openDialog(instance, false);
        track('click_gift_details', {product_id: gift && gift.handle});
        setMode(instance, giftId);
      } else if (target.matches('[data-km-gift-variant]')) {
        selectVariant(instance, target.closest('[data-km-gift-detail-view]'), target.getAttribute('data-km-gift-variant'));
      } else if (target.matches('[data-km-gift-add]') && !target.disabled) {
        var detail = target.closest('[data-km-gift-detail-view]');
        var selected = window.KMCartGiftRules.findGiftVariant(instance.config, detail.dataset.selectedVariant);
        track('click_add_free_gift', {product_id: selected && selected.gift.handle});
        instance.service.chooseGift(detail.dataset.selectedVariant).then(function () {
          if (instances.has(section)) closeDialog(instance);
        }).catch(function () {});
      } else if (target.matches('[data-km-gift-remind-later]')) {
        event.preventDefault();
        event.stopPropagation();
        writeStorage(localStorage(), reminderKey, Date.now());
        closeDialog(instance);
      } else if (target.matches('[data-km-gift-gallery-prev], [data-km-gift-gallery-next], [data-km-gift-gallery-index]')) {
        var gallery = target.closest('[data-km-gift-gallery]');
        var index = target.getAttribute('data-km-gift-gallery-index');
        setGalleryIndex(gallery, index == null ? Number(gallery.dataset.activeIndex)
          + (target.matches('[data-km-gift-gallery-prev]') ? -1 : 1) : Number(index));
        track('click_gift_image_navigation');
      }
    });
    bind(document, 'click', function (event) {
      if (!event.target.closest || event.target.closest('[data-km-gift-help], [data-km-gift-help-tooltip]')) return;
      var tooltip = section.querySelector('[data-km-gift-help-tooltip]');
      if (tooltip) tooltip.hidden = true;
      var help = section.querySelector('[data-km-gift-help]');
      if (help) help.setAttribute('aria-expanded', 'false');
    });
    bind(document, 'keydown', function (event) {
      if (event.key === 'Tab' && instance.dialog && !instance.dialog.hidden) {
        var controls = Array.from(instance.dialog.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )).filter(function (node) { return node.getClientRects().length > 0; });
        var first = controls[0];
        var last = controls[controls.length - 1];
        if (first && (controls.indexOf(document.activeElement) < 0
          || event.shiftKey && document.activeElement === first
          || !event.shiftKey && document.activeElement === last)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          (event.shiftKey ? last : first).focus();
        }
      }
      if (event.key === 'Escape') {
        if (instance.dialog && !instance.dialog.hidden) {
          instance.suppressEscapeKeyUp = true;
          event.preventDefault();
          event.stopImmediatePropagation();
          closeDialog(instance);
        }
        var tooltip = section.querySelector('[data-km-gift-help-tooltip]');
        if (tooltip) tooltip.hidden = true;
        var help = section.querySelector('[data-km-gift-help]');
        if (help) help.setAttribute('aria-expanded', 'false');
      }
    }, true);
    bind(document, 'keyup', function (event) {
      if (event.key === 'Escape' && instance.suppressEscapeKeyUp) {
        instance.suppressEscapeKeyUp = false;
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
    var touch;
    bind(section, 'touchstart', function (event) {
      var gallery = event.target.closest('[data-km-gift-gallery]');
      touch = gallery && event.touches.length === 1
        ? {gallery: gallery, x: event.touches[0].clientX, y: event.touches[0].clientY} : null;
    }, {passive: true});
    var trackedScrolls = new Set();
    bind(section, 'scroll', function (event) {
      if (!instance.detailId || !event.target.matches
        || !event.target.matches('.km-gift-dialog, .km-gift-detail__content')) return;
      if (trackedScrolls.has(instance.detailId)) return;
      trackedScrolls.add(instance.detailId);
      var gift = instance.config.gifts.find(function (value) { return value.id === instance.detailId; });
      track('scroll_gift_details', {product_id: gift && gift.handle});
    }, true);
    bind(section, 'touchend', function (event) {
      if (!touch || !event.changedTouches.length) return;
      var deltaX = event.changedTouches[0].clientX - touch.x;
      var deltaY = event.changedTouches[0].clientY - touch.y;
      if (Math.abs(deltaX) >= 40 && Math.abs(deltaX) > Math.abs(deltaY)) {
        setGalleryIndex(touch.gallery, Number(touch.gallery.dataset.activeIndex) + (deltaX < 0 ? 1 : -1));
      }
      touch = null;
    }, {passive: true});
    document.dispatchEvent(new CustomEvent('km:cart-gifts:ready', {detail: {service: instance.service}}));
    refresh();
  }

  function destroy(section) {
    var instance = instances.get(section);
    if (!instance) return;
    closeDialog(instance);
    instance.cleanup.forEach(function (cleanup) { cleanup(); });
    instance.service.destroy();
    if (instance.drawer && instance.drawer.destroy) instance.drawer.destroy();
    instances.delete(section);
    if (active === instance) { active = null; window.KMCartGiftService = null; }
  }

  window.KMCartGifts = {init: init, destroy: destroy,
    getDrawer: function () { return active && active.drawer; },
    getService: function () { return active && active.service; }};
  function boot() { document.querySelectorAll('[data-km-cart-gifts-section]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once: true});
  else boot();
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.matches('[data-km-cart-gifts-section]')) init(event.target);
    else event.target.querySelectorAll('[data-km-cart-gifts-section]').forEach(init);
    if (active && active.drawer && active.drawer.drawer.refreshOpenButtons) {
      active.drawer.drawer.refreshOpenButtons();
    }
  });
  document.addEventListener('shopify:section:unload', function (event) {
    if (event.target.matches('[data-km-cart-gifts-section]')) destroy(event.target);
    else event.target.querySelectorAll('[data-km-cart-gifts-section]').forEach(destroy);
  });
})(window, document);
